import { useState, useEffect, useCallback } from "react";
import { requestAuthGet } from "../api/authInstance";
import { requestGet } from "../api/coreInstance";

function useAPI(url, initialParams = {}, headers) {
  const [params, setParams] = useState(initialParams);
  const [data, setData] = useState(null);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response;
      if (headers) {
        response = await requestGet(url, {
          params,
          headers,
        });
      } else {
        response = await requestAuthGet(url, { params });
      }

      const result = response.data?.data;
      const pagination = {
        page: response.data?.page,
        limit: response.data?.pageCount,
        total: response.data?.total,
      };
      setData(result);
      setPagination(pagination);
    } catch (error) {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [url, params]);

  const handleQueryParams = useCallback(
    (newParams) => {
      setParams((prevParams) => ({
        ...prevParams,
        ...newParams,
      }));
    },
    [setParams],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData, params]);

  return [data, loading, fetchData, params, handleQueryParams, pagination];
}

export default useAPI;
